import { Button, Dropdown, Input, Notification, Tooltip, toast } from 'components/ui'
import { TagContext } from 'contexts/TagContext';
import React, { useContext, useEffect, useState } from 'react'
import { TbArchive, TbArrowLeft, TbCaretLeft, TbCheck, TbPencil, TbPlus, TbTag, TbTags } from 'react-icons/tb'
import Tag from './Tag';

export const defaultTagColors = [
// "#FFAB91",
// "#FFCC80",
// "#FFD180",
// "#FFD54F",
// "#FFD700",
// "#FFE082",
// "#FFF176",
// "#A5D6A7",
// "#81C784",
// "#80CBC4",
// "#4DB6AC",
// "#00CED1",
// "#00FFFF",
// "#81D4FA",
// "#CE93D8",
// "#9575CD",
// "#90A4AE",
// "#B0BEC5",
// "#AED581",
// "#8BC34A",
// "#689F38",
// "#E57373",
// "#FF8A65",
// "#F06292",
// "#BA68C8",
// "#AB47BC",
// "#9C27B0",
// "#6C27B0",
"#FF6347",
"#FF8C00",
"#FFA500",
"#FFD700",
"#FFA07A",
"#FF4500",
"#FF0000",
// "#8B0000",
// "#600000",
// "#DC143C",
// "#B22222",
// "#FF69B4",
// "#FF1493",
// "#FF00FF",
"#8A2BE2",
"#4B0082",
"#483D8B",
"#4169E1",
"#0000FF",
"#00BFFF",
"#00CED1",
"#008080",
"#008B8B",
"#2E8B57",
"#32CD32",
"#228B22",
"#006400",
"#808000",
];

export default function PostTagsButton({
  onClickTag = (tag) => void 0,
  selectedTags = [],
  customLabel = "Insert tags",
  closeOnSelect = false,
  defaultShowArchive = false,
  buttonClassName = "",
  portal = false
}) {

  const { isLoadingTags, tags, createTag, toggleActiveTag, updateTag } = useContext(TagContext);
  const [ isCreating, setIsCreating ] = useState(false);
  const [ showArchive, setShowArchive ] = useState(defaultShowArchive);
  const [ openCreate, setOpenCreate ] = useState(false);
  const [ id, setId ] = useState();
  const [ name, setName ] = useState("");
  const [ color, setColor ] = useState();
  const [ isOpen, setIsOpen ] = useState(false);

  const onSubmit = async () => {
    setIsCreating(true);
    !id ? await createTag(name, color) : await updateTag(id, name, color)
    resetState();
    setOpenCreate(false);
    setIsCreating(false);
  }

  const onEdit = (tag) => {
    setId(tag.id)
    setName(tag.name);
    setColor(tag.color);
    setOpenCreate(true);
  }

  const resetState = () => {
    setName("");
    setColor(defaultTagColors[Math.floor(Math.random()*defaultTagColors.length)]);
    setId("");
  }

  useEffect(() => {
    resetState();
  }, [])

  const handleTagClick = (tag) => {
    onClickTag(tag);
    if (closeOnSelect) {
      setIsOpen(false);
    }
  };

  return (
    <Dropdown
      placement="bottom-start"
      parentClassName={`w-full`}
      menuClass={`w-[275px] max-h-[285px] overflow-y-auto`}
      portal={portal}
      isOpen={isOpen}
      onToggle={(open) => setIsOpen(open)}
      renderTitle={
        <Button
          size="sm"
          className={`!rounded-xl text-sm flex items-center text-tertiary-600 bg-secondary-300 ${buttonClassName}`}
          // color="var(--secondary-color-300)"
          variant="twoTone"
          loading={isLoadingTags}
          icon={selectedTags?.length 
            ? selectedTags?.length > 1
              ? <TbTags color={selectedTags[0].color} />
              : <TbTag color={selectedTags[0].color} />
            : <TbTags />
          }
          onClick={resetState}
        >
          {selectedTags?.length 
            ? <>
              <span className='inline-block max-w-[100px] overflow-hidden text-ellipsis align-middle'>{selectedTags[0].name}</span>
              {selectedTags.length > 1 
                ? <>
                  &nbsp;<small>+{selectedTags.length - 1}</small>
                </>
                : <></>
              }
            </>
            : <>
              {customLabel}
            </>
          }
        </Button>
      }
    >
      {openCreate
        ? <>
          <Dropdown.Item variant="header">
            <div className='flex items-center justify-between px-4 py-2 w-full'>
              <TbArrowLeft onClick={() => setOpenCreate(false)} className='text-lg cursor-pointer' />
              <span>{id ? `Edit Tag` : `Create Tag`}</span>
              <TbCaretLeft className='text-lg invisible' />
            </div>
          </Dropdown.Item>
          <Dropdown.Item variant="divider" />
          <Dropdown.Item variant="header">
            <div className='flex flex-col gap-2 px-4 py-2'>
              <Input
                placeholder="Insert tag name..."
                className="border-gray-200 rounded-lg text-sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <div className='grid grid-cols-7 gap-1'>
                {defaultTagColors.map(_color => (
                  <div className='overflow-visible cursor-pointer' onClick={() => setColor(_color)}>
                    <div className={`transition-all rounded h-[32px] relative hover:shadow hover:z-[2] flex items-center justify-center shadow-[${_color}] ${_color == color && `z-[2] scale-[0.85]`}`} style={{ background: _color }}>
                      {color == _color && 
                        <TbCheck className='text-lg text-white' />
                      }
                    </div>
                  </div>
                ))}
              </div>
              <Button 
                variant="solid" 
                className="rounded-lg"
                onClick={onSubmit}
                loading={isCreating}
              >
                {id ? `Update Tag` : `Create Tag`}
              </Button>
            </div>
          </Dropdown.Item>
        </>
        : <>
          <Dropdown.Item>
            <div onClick={(e) => { setOpenCreate(true); e.stopPropagation(); }} className="w-full flex items-center justify-between gap-2 py-2">
              <div className='flex items-center gap-2'>
                <TbPlus className='h-6 md:text-2xl text-primary-600' />
                <span>Create new tag</span>
              </div>
            </div>
          </Dropdown.Item>
          {!!tags?.filter(e => !!e.active)?.length && 
            <Dropdown.Item variant="divider" />
          }
          {tags?.filter(e => !!e.active)?.map(tag => (
            <Tag 
              key={tag.id} 
              tag={tag} 
              onEdit={() => onEdit(tag)}
              onClickTag={() => handleTagClick(tag)}
              selected={selectedTags.find(e => e.id == tag.id)}
              closeOnSelect={closeOnSelect}
            />
          ))}
          {!!showArchive && tags?.filter(e => !e.active)?.map(tag => (
            <Tag 
              key={tag.id} 
              tag={tag} 
              onEdit={() => onEdit(tag)}
              onClickTag={() => handleTagClick(tag)}
              selected={selectedTags.find(e => e.id == tag.id)}
            />
          ))}
          {!!tags?.filter(e => !e.active)?.length &&  
            <Dropdown.Item>
              <div onClick={(e) => { e.stopPropagation(); setShowArchive(!showArchive) }} className="w-full flex items-center justify-between gap-2 py-2 px-2">
                <span>{showArchive ? `Hide archived tags` : `View archived tags`}</span>
              </div>
            </Dropdown.Item>
          }
        </>
      }
    </Dropdown>
  )
}
